<template>
  <article class="container">
    <section
      id="content"
      class="content error_wrap"><!-- 페이지 더블 클래스 : error_wrap  -->
      <div class="section_content">
        <div class="error_box">
          <p class="error_txt">
            찾고 있는 리소스가 제거되었거나 이름이 변경되었거나 일시적으로 사용할 수 없습니다.
            <br>잠시후에 다시 확인해 보세요.
          </p>
        </div>
        <div class="btn_wrap">
          <a :href="multicampusMainLink" target="_self" class="btn_basic"><span class="btn_text">메인으로</span></a>
        </div>
      </div>
    </section>
  </article>
</template>

<script>
import { isEmpty } from 'lodash'

export default {
  name: 'PageNotFound',
  computed: {
    multicampusMainLink () {
      return window.location.protocol + '//' + window.location.hostname + (isEmpty(window.location.port) ? '' : ( ':' + window.location.port))
    }
  }

}

</script>



// WEBPACK FOOTER //
// src/components/pages/contents/error/PageNotFound.vue